import {useQuery} from '@tanstack/react-query';
import axios from 'axios';

const useYoungPersonCategories = () => {
  const {data, isLoading, error, refetch} = useQuery({
    queryKey: ['young-person-categories'],
    queryFn: async () => await axios.get('/api/young-person-categories').then((res) => res.data),
    staleTime: Infinity,
  });

  return {data, isLoading, error, refetch};
};

export default useYoungPersonCategories;
